module.exports = __webpack_public_path__ + "static/media/dr_julie_nos_welcome_video.bf19a9d0.mov";